import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const MusicPlayerContainer = styled.div`
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 2;
`;

const PlayButton = styled.button`
    background: ${(props) => props.isPlaying ? '#f48fb1' : '#e91e63'};
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 1em;
    outline: none;

    &:hover {
        opacity: 0.8;
    }
`;

function RomanticMusic({ audioSource }) {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        const audioElement = audioRef.current; // Capture the current ref value

        const playMusic = () => {
            if (audioElement) {
                audioElement.play().catch(error => {
                    // Autoplay was prevented. You might want to log this or show a message.
                    console.error("Autoplay prevented:", error);
                });
                setIsPlaying(true);
            }
        };

        // Attempt to play on initial mount
        playMusic();

        // Add a listener to try playing again on first user interaction (e.g., click)
        const handleFirstInteraction = () => {
            playMusic();
            window.removeEventListener('click', handleFirstInteraction);
            window.removeEventListener('touchstart', handleFirstInteraction);
            window.removeEventListener('keydown', handleFirstInteraction);
        };

        window.addEventListener('click', handleFirstInteraction);
        window.addEventListener('touchstart', handleFirstInteraction);
        window.addEventListener('keydown', handleFirstInteraction);

        return () => {
            window.removeEventListener('click', handleFirstInteraction);
            window.removeEventListener('touchstart', handleFirstInteraction);
            window.removeEventListener('keydown', handleFirstInteraction);
            if (audioElement) {
                audioElement.pause();
            }
        };
    }, [audioSource]);

    const togglePlay = () => {
        if (audioRef.current) {
            if (audioRef.current.paused) {
                audioRef.current.play();
                setIsPlaying(true);
            } else {
                audioRef.current.pause();
                setIsPlaying(false);
            }
        }
    };

    return (
        <MusicPlayerContainer>
            <audio ref={audioRef} src={audioSource} loop />
            <PlayButton isPlaying={isPlaying} onClick={togglePlay}>
                {isPlaying ? 'Pause Music' : 'Play Romantic Music'}
            </PlayButton>
        </MusicPlayerContainer>
    );
}

export default RomanticMusic;